#!/usr/bin/env node

import { getProgram } from '@/program'
import './imports'
const program = getProgram()

/** display help if no argument has been provided */
if (process.argv.length === 2) {
  program.help()
}

program.parse()
